import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zh from './locales/zh.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      zh: {
        translation: zh
      },
      en: {
        translation: en
      }
    },
    lng: 'auto', // 自动检测语言
    fallbackLng: 'en', // 默认语言
    detection: {
      order: ['navigator', 'localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        // 如果检测到的语言是中文（zh, zh-CN, zh-Hans等），则返回zh
        if (lng && lng.toLowerCase().includes('zh')) {
          return 'zh';
        }
        // 否则返回英语
        return 'en';
      }
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 